export function buildClassifyKey(text, params) {
  const p = params || {};
  const provider = p.classifierProvider || 'openai';
  const model = p.classifierModel || 'gpt-4o';
  const supportsThinking = provider === 'anthropic' && (
    model === 'claude-sonnet-4-6'
    || model === 'claude-sonnet-5'
    || model === 'claude-opus-5'
  );
  const thinking = supportsThinking
    ? (p.classifierThinking || (model === 'claude-sonnet-4-6' ? 'off' : 'adaptive'))
    : '';
  const effort = supportsThinking
    ? (p.classifierEffort || (model === 'claude-sonnet-4-6' ? 'medium' : 'high'))
    : '';
  return [
    text || '',
    provider,
    model,
    p.classifierPrompt || '',
    p.classifierFieldCount ?? 1,
    p.classifierMinConfidence ?? 0.5,
    p.classifierFieldDetail || 'full',
    p.classifierFieldFormat || 'json',
    thinking,
    effort,
  ].join('::');
}
